import * as React from "react";
import { forwardRef } from "react";
const SvgArrowFromLeft = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "none",
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M16.6484 8.64844H6.64844M12.6484 4.64844L16.6484 8.64844L12.6484 12.6484M0.648438 0.648438V16.6484",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.3
}));
const ForwardRef = forwardRef(SvgArrowFromLeft);
export default ForwardRef;
